import { createSlice } from '@reduxjs/toolkit';

const brotherPlusPrintersSlice = createSlice({
  name: 'brotherPlusPrinters',
  initialState: {
    success: false,
    loading: false,
    printers: null,
    error: null,
  },
  reducers: {
    fetchBrotherPlusPrintersRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    fetchBrotherPlusPrintersSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.printers = action.payload;
    },
    fetchBrotherPlusPrintersFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
      state.success = false;
    },
  },
});

export const {
  fetchBrotherPlusPrintersRequest,
  fetchBrotherPlusPrintersSuccess,
  fetchBrotherPlusPrintersFailure
} = brotherPlusPrintersSlice.actions;

export default brotherPlusPrintersSlice.reducer;
